<script lang="ts">
    import RewardsPageWidgetCard from "@apps/rewards/widgets/rewards_page_widgets/components/RewardsPageWidgetCard.svelte";

    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import ImageSkeleton from "@components/skeletons/ImageSkeleton.svelte";
    import StackedSkeleton from "@components/skeletons/StackedSkeleton.svelte";
</script>

<div class="gw-rd-ways-to-earn-page-widget-skeleton-title">
    <BaseSkeleton width="100%" height="28px" />
</div>
<div class="gw-rd-ways-to-earn-page-widget-skeleton-wrapper">
    <div class="gw-rd-ways-to-earn-page-widget-skeleton-main">
        {#each { length: 6 } as _, index (index)}
            <RewardsPageWidgetCard>
                <ImageSkeleton
                    slot="icon"
                    class="gw-rd-ways-to-earn-page-widget-skeleton-main__image"
                    ratio={1}
                />
                <BaseSkeleton slot="title" width="50%" height="20px" />
                <div
                    class="gw-rd-ways-to-earn-page-widget-skeleton-main__content"
                    slot="reward"
                >
                    <StackedSkeleton
                        count={2}
                        gap="10px"
                        height="8px"
                        width="70%"
                    />
                </div>
            </RewardsPageWidgetCard>
        {/each}
    </div>
</div>

<style lang="postcss">
    .gw-rd-ways-to-earn-page-widget-skeleton-title {
        width: 100%;
        max-width: 320px;
        margin: 0 auto;
    }

    .gw-rd-ways-to-earn-page-widget-skeleton-wrapper {
        width: 100%;
        max-width: 1118px;
    }

    .gw-rd-ways-to-earn-page-widget-skeleton-main {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(288px, 359px));
        justify-content: center;
        gap: var(--gw-rd-space-10);
        pointer-events: none;

        :global(&__image) {
            width: 100%;
        }

        &__content {
            display: flex;
            justify-content: center;
            margin-top: var(--gw-rd-space-4);
        }
    }
</style>
